<section>

  <form class="needs-validation" novalidate [formGroup]="formRemissionDetail">
    <div class="container-style row mb-2">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-between  align-items-center">
        <div class="d-flex gap-4 ps-2">
          <div>
            <label class="text-muted small d-block">Equipo</label>
            <span class="fw-bold">
              {{articleObject.code == 0 ? '' : articleObject.code }}
            </span>
          </div>
          <div>
            <label class="text-muted small d-block">Cód. Alt.</label>
            <span class="fw-bold">
              {{articleObject.alterCode}}
            </span>
          </div>
          <div>
            <label class="text-muted small d-block">Nombre</label>
            <span class="fw-bold text-uppercase">
              {{articleObject.name}}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="container-style row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-6">
        <app-custom-input-decimal formControlName="hourometer" [labelText]="'Horómetro Actual'" [required]="true"
          (onChangeNumber)="changeHourmeter($event)"></app-custom-input-decimal>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-6">
        <app-custom-input-number formControlName="hoursDays" [labelText]="'Horas de uso por días'"
          [required]="true"></app-custom-input-number>
      </div>
      <div class="col-lg-12 col-md-12 col-12 d-flex justify-content-end mt-3">
        <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
          [disabled]="disableButton" (onClick)="send()">
        </app-custom-button>
      </div>
    </div>
  </form>
</section>